(() => {
  if (customElements.get('pb-deferred-video-poster')) return;
  customElements.define('pb-deferred-video-poster', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video[data-pb-poster]');
      if (!video) return;
      this.revealPoster = () => {
        if (video.dataset.pbPoster) {
          let poster = video.dataset.pbPoster;
          try {
            const url = new URL(poster, location.href);
            if (url.hostname === 'cdn.shopify.com' || (url.origin === location.origin && url.pathname.startsWith('/cdn/shop/'))) {
              const width = Math.min(1600, Math.ceil((video.clientWidth || this.clientWidth || 400) * (window.devicePixelRatio || 1) / 100) * 100);
              url.searchParams.set('width', String(width));
              poster = url.href;
            }
          } catch (_) {}
          video.poster = poster;
          delete video.dataset.pbPoster;
        }
        this.disconnectedCallback();
      };
      this.addEventListener('pointerdown', this.revealPoster);
      this.addEventListener('focusin', this.revealPoster);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.revealPoster();
        }, { rootMargin: '200px 0px' });
        this.observer.observe(this);
      } else this.revealPoster();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('pointerdown', this.revealPoster);
      this.removeEventListener('focusin', this.revealPoster);
    }
  });
})();
